// extracted by mini-css-extract-plugin
module.exports = {"movie":"Movie_movie__2srby","poster":"Movie_poster__797WR","dropdown":"Movie_dropdown__22-Hb","image-container":"Movie_image-container__1uHKk"};